import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmationService } from '../../core/services/confirmation.service';
import { ButtonComponent } from '../ui-button/button.component';

/**
 * BE-1491: плашка «Сессия закончилась» — сессия кончилась на странице с несохранёнными
 * изменениями, и на вопрос человек ответил «Остаться». Не закрывается и видна поверх открытых
 * окон (на интеграциях — поверх окна с секретом), пока человек не уйдёт со страницы или не
 * войдёт; состояние и его сброс — в AuthService. На время вопроса «Уйти / Остаться» (уход по
 * ссылке) прячется: «Войти» поверх него увела бы на вход, оставив вопрос без ответа.
 *
 * BE-1518: второй вариант — в соседней вкладке вошли под другим аккаунтом: запросы вкладки с его
 * парой не уходят, «Обновить страницу» перезагружает вкладку под ним.
 */
@Component({
  selector: 'app-session-ended-banner',
  standalone: true,
  imports: [ButtonComponent],
  template: `
    @if (auth.otherUserSignedIn() && !confirmation.showModal()) {
      <div class="session-ended" role="alert">
        <span class="text"
          >В соседней вкладке вошли под другим аккаунтом — скопируйте данные и
          обновите страницу</span
        >
        <app-button variant="primary" (clicked)="auth.reloadTab()"
          >Обновить страницу</app-button
        >
      </div>
    } @else if (auth.sessionEndedOnForm() && !confirmation.showModal()) {
      <div class="session-ended" role="alert">
        <span class="text"
          >Сессия закончилась — скопируйте данные и войдите снова</span
        >
        <app-button variant="primary" (clicked)="auth.signInAgain()"
          >Войти</app-button
        >
      </div>
    }
  `,
  styles: [
    `
      /* Выше окон (app-modal — 1100), ниже подсказки PWA (1200) и тостов (10000). */
      .session-ended {
        position: fixed;
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1150;
        display: flex;
        align-items: center;
        gap: 16px;
        width: max-content;
        max-width: calc(100vw - 32px);
        box-sizing: border-box;
        padding: 12px 16px;
        background: var(--surface);
        color: var(--text-primary);
        border: 1px solid var(--accent-orange);
        border-radius: var(--radius-md);
        box-shadow: var(--shadow-modal);
        font-size: 14px;
        line-height: 1.4;
      }
      .text {
        flex: 1;
        min-width: 0;
      }
      @media (max-width: 480px) {
        .session-ended {
          left: 16px;
          right: 16px;
          width: auto;
          max-width: none;
          transform: none;
          flex-direction: column;
          align-items: stretch;
          gap: 8px;
        }
      }
    `,
  ],
})
export class SessionEndedBannerComponent {
  protected readonly auth = inject(AuthService);
  protected readonly confirmation = inject(ConfirmationService);
}
